// eslint-disable-next-line import/no-cycle
import isbot from 'isbot';
import { getSuperProperties } from '../../new-site-app/utils/eventSuperProperties';
import userIdentifyData from "../../new-site-app/utils/userIdentifyData";

export function identify(userId) {
  window.analytics.alias(userId);
  window.analytics.identify(userId);
}

export function updateUserInfo() {
  const userData = userIdentifyData();
  if (typeof userData.id === 'undefined' || isbot(navigator.userAgent)) {
    return;
  }
  window.analytics.identify(userData.id, userData);
}

export function eventTracker(event, data) {
  if (isbot(navigator.userAgent)) {
    return;
  }
  window.analytics.track(event, { ...data, ...getSuperProperties() });
}
